<template>
  <div class="message-dialogue" :class="{ backdrop: backdrop }">
    <div class="dialogue-window" :appearance="compAppearance">
      <div class="banner">
        <img class="flash" :src="flash" alt="" />
        <img class="bulb" :src="bulb" alt="" />
      </div>

      <h1 class="title">Oh Dear!</h1>

      <ul class="error-list">
        <li class="error">
          We’re sorry, but something went wrong. Please try again, and if this persists, contact us at the email below.
        </li>
        <li><a href="mailto:hubinfo@springboardservices.ca">hubinfo@springboardservices.ca</a></li>
        <li class="error-code">{{ error }}</li>
      </ul>

      <button type="button" class="ok-button" @click="close">OK</button>
    </div>
  </div>
</template>

<script>
import flash from '@/assets/img/messages/flash_light.svg';
import bulb from '@/assets/img/messages/light_bulb.svg';

export default {
  name: 'message-dialogue',

  data() {
    return {
      flash,
      bulb,
      error: this.$store.getters.getError,
    };
  },

  props: {
    backdrop: {
      type: Boolean,
      default: true,
    },
    appearance: {
      type: Object,
      default: () => ({ w: 80, h: 70 }),
    },
  },

  computed: {
    compAppearance() {
      const height = this.appearance.h || 70;
      const width = this.appearance.w || 80;

      return { h: height, w: width };
    },
  },

  methods: {
    close() {
      this.$store.dispatch('clearError');
    },
  },
};
</script>

<style scoped>
.message-dialogue {
  position: fixed;
  top: 0%;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
}

.backdrop {
  background-color: rgba(0, 0, 0, 0.6);
}

.dialogue-window {
  position: relative;
  width: 556px;
  max-width: 80%;
  max-height: 90%;

  border-radius: 0.8em;
  overflow: hidden;

  font-size: 18px;
  text-align: center;
  color: #5c5c5c;

  background: #ffe6e6;
}

.banner {
  position: relative;
  width: 100%;
  height: 221px;

  background-image: linear-gradient(0deg, #fa4646 0%, #b80155 100%);
  border-radius: 8px;
}

@keyframes flashing {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.banner > .flash {
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translateX(-50%);
  height: 42%;

  animation: flashing 1s ease-in-out 0s infinite alternate;
}

.banner > .bulb {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translateX(-50%);
  height: 70%;
}

h1.title {
  font-size: 2em;
  color: inherit;
}

.error-list > li {
  margin: 1em 3em;
}

.error-code {
  color: red;
}

.ok-button {
  display: block;
  height: 2em;
  width: 10em;
  margin: 2em auto 2em auto;

  font-size: 21px;
  color: #ffffff;
  text-align: center;

  background-image: linear-gradient(0deg, #ffa337 0%, #de8264 99%);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  border: none;
}
</style>
